import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import LinkTextM from "@common/components/text/LinkTextM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import base64 from "@common/utils/base64"
import { IS_WEB } from "@common/utils/mobileUtils"
import {
    apiIdle,
    apiRequest,
    apiRequestWithPrerequest,
} from "@data/redux/actions/api"
import { formatDate } from "@data/utility/Utils"
import {
    isSubscriptionPaused,
    isSubscriptionRecurring,
    isSubscriptionTrialing,
} from "@data/utility/dataUtils"
import { useNavigation } from "@react-navigation/native"
import * as WebBrowser from "expo-web-browser"
import moment from "moment"
import React, { useState } from "react"
import { ActivityIndicator, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { AvailabilitySlotsM } from "./AvailabilitySlotsM"
import { PrivilegesChecklistM } from "../../../auth/PricingColumnM"
import ObjectivesSummaryDisplay from "../../../common/account/ObjectivesSummaryDisplay"
import { useApiStatus } from "../../../common/hooks/useApiStatus"
import { studentsService } from "../../../data/services/studentsService"
import {
    PrioritizedSchoolSubjects,
    SchoolSubjectBadge,
} from "../../../tutor/students/ProfilDetails"
import { ProfileSection } from "../ProfileSection"
import { SubscriptionProductChip } from "../SubscriptionPrivilegeChip"
import ChangePaymentCollectionDayModal from "./ChangePaymentCollectionDayModal"
import { ProductIcon, subscriptionStatusNames } from "./MySubscriptionScreen"

function MySubscriptionInfos(props) {
    const {
        billingPortalUrl,
        user,
        plannedTableData,
        currentTableData,
        initialShowDetails = false,
        hideSubscriptionSection = false,
        hideManageSection = false,
        onOpenInvoices,
    } = props

    const productName = user?.subscription_state?.plan

    const commitmentEndsAt = user?.commitment_ends_at
        ? moment(user?.commitment_ends_at)
        : null
    const commitmentEndsAtFormatted = commitmentEndsAt?.isAfter(moment())
        ? commitmentEndsAt.format("DD MMMM YYYY")
        : null

    const nextPaymentAmount =
        user?.upcoming_invoice_data?.amount_due > 0
            ? user?.upcoming_invoice_data?.amount_due
            : null //(user?.planned_subscription?.amount + user?.stripe_balance)

    const [nextPaymentAttempt, setNextPaymentAttempt] = useState(
        user?.upcoming_invoice_data?.next_payment_attempt ??
            user?.planned_subscription?.start_date
    )

    const [showDetails, setShowDetails] = useState(initialShowDetails)

    const navigation = useNavigation()

    const [openPaymentCollectionDayModal, setOpenPaymentCollectionDayModal] =
        useState(false)
    const handleOpenPaymentCollectionDayModal = () =>
        setOpenPaymentCollectionDayModal(!openPaymentCollectionDayModal)

    const [payment_collection_day, setpayment_collection_day] = useState(
        "Ma date de prélèvement (le " + user?.payment_collection_day + ")"
    )

    const [loading, setLoading] = useState(false)

    useApiStatus(
        studentsService.studentChangePaymentCollectionDay, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData) => {
            setpayment_collection_day(
                "Ma date de prélèvement (le " +
                    successData?.payment_collection_day +
                    ")"
            )
            setLoading(false)
        } // success callback
    )
    const handleUpdatePaymentCollectionDay = (newDay) => {
        setLoading(true)
        if (
            !user ||
            !user.upcoming_invoice_data ||
            !user.upcoming_invoice_data.next_invoice_attempt
        )
            return

        setpayment_collection_day(`Ma date de prélèvement (le ${newDay})`)

        const [year, month, day] =
            user.upcoming_invoice_data.next_invoice_attempt
                .split("-")
                .map(Number)
        const date = new Date(year, month - 1, day) // Les mois sont indexés à partir de 0 en JavaScript

        // Ajouter les jours
        date.setDate(date.getDate() + newDay)

        // Formater la nouvelle date
        const newDate = date.toISOString().split("T")[0]
        setNextPaymentAttempt(newDate)
    }

    return (
        <>
            {user?.current_holiday_courses?.length > 0 && (
                <ProfileSection
                    title={"Mes stages"}
                    noBorder
                    style={{
                        paddingBottom: 20,
                        width: "100%",
                    }}
                >
                    {user?.current_holiday_courses?.map((course) => {
                        return (
                            <View key={course?.id} style={{ marginTop: 10 }}>
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: 10,
                                    }}
                                >
                                    <TextM
                                        fontWeight={"Medium"}
                                        style={{ marginRight: 10 }}
                                        wrap
                                    >
                                        {course?.name}
                                    </TextM>
                                    <TextM wrap>
                                        {moment(course?.start_date).format(
                                            "DD MMMM"
                                        )}{" "}
                                        -{" "}
                                        {moment(course?.end_date).format(
                                            "DD MMMM"
                                        )}
                                    </TextM>
                                </View>
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        marginBottom: 10,
                                    }}
                                >
                                    <TextM wrap style={{ marginRight: 10 }}>
                                        {course?.class}
                                    </TextM>
                                    <SchoolSubjectBadge
                                        style={{ marginRight: 10 }}
                                        schoolSubject={props.schoolSubjects?.find(
                                            (subject) =>
                                                subject?.id ===
                                                course?.first_school_subject_id
                                        )}
                                    />
                                    {course?.second_school_subject_id && (
                                        <SchoolSubjectBadge
                                            style={{ marginRight: 10 }}
                                            schoolSubject={props.schoolSubjects?.find(
                                                (subject) =>
                                                    subject?.id ===
                                                    course?.second_school_subject_id
                                            )}
                                        />
                                    )}
                                </View>
                            </View>
                        )
                    })}
                </ProfileSection>
            )}
            {(isSubscriptionPaused(user) ||
                isSubscriptionRecurring(user) ||
                isSubscriptionTrialing(user)) && (
                <ProfileSection
                    title={"Mon accompagnement"}
                    noBorder
                    style={{
                        paddingBottom: 20,
                        paddingHorizontal: 20,
                        width: "100%",
                    }}
                >
                    {/* Objectives or subjects fallback */}
                    <View style={{ marginBottom: 15, width: "100%" }}>
                        <TextM fontWeight="Medium" style={{ marginBottom: 8 }}>
                            {user?.pedagogical_objectives?.length > 0
                                ? "Mes objectifs"
                                : "Mes matières"}
                        </TextM>
                        {user?.pedagogical_objectives?.length > 0 ? (
                            // Display objectives using existing component
                            <ObjectivesSummaryDisplay
                                objectives={user.pedagogical_objectives || []}
                                schoolSubjects={props.schoolSubjects || []}
                                objectiveNeeds={user?.objective_needs || []}
                                compact={true}
                                style={{ marginTop: 0 }}
                            />
                        ) : (
                            // Fallback to subjects
                            <PrioritizedSchoolSubjects
                                student={user}
                                warningMode
                                style={{ marginBottom: 5 }}
                            />
                        )}
                        <FilledButtonM
                            mode={"outlined"}
                            icon={"book"}
                            color={theme.colors.primary}
                            onPress={() => {
                                const userEmail = base64.encode(user?.email)
                                navigation.navigate("subscription-continuity", {
                                    user: userEmail,
                                    subjectsOnly: true,
                                })
                            }}
                            style={{
                                marginTop: 10,
                                alignSelf: "center",
                            }}
                            labelStyle={{ fontSize: 12, height: 16 }}
                            contentStyle={{ height: 35 }}
                            label={"Modifier mes matières"}
                        />
                    </View>

                    {/* Availability */}
                    <View style={{ marginBottom: 15, width: "100%" }}>
                        <TextM fontWeight="Medium" style={{ marginBottom: 8 }}>
                            Mes disponibilités
                        </TextM>
                        {user?.slots_possible?.length > 0 ? (
                            <AvailabilitySlotsM
                                slots={user?.slots_possible}
                                inline
                            />
                        ) : (
                            <TextM
                                wrap
                                fontWeight={"Medium"}
                                color={theme.colors.warning}
                            >
                                Pas de créneaux renseignés
                            </TextM>
                        )}
                        <FilledButtonM
                            mode={"outlined"}
                            icon={"calendar-alt"}
                            color={theme.colors.primary}
                            onPress={() => {
                                const userEmail = base64.encode(user?.email)
                                navigation.navigate("subscription-continuity", {
                                    user: userEmail,
                                    availabilityOnly: true,
                                    fromParentPortal: true,
                                })
                            }}
                            style={{
                                marginTop: 10,
                                alignSelf: "center",
                            }}
                            labelStyle={{ fontSize: 12, height: 16 }}
                            contentStyle={{ height: 35 }}
                            label={"Modifier mes disponibilités"}
                        />
                    </View>
                </ProfileSection>
            )}
            {!hideSubscriptionSection && (
                <ProfileSection
                    title={"Mon abonnement"}
                    noBorder
                    style={{
                        paddingBottom: 20,
                        width: "100%",
                    }}
                >
                    <View
                        style={{
                            width: "100%",
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                marginTop: 20,
                            }}
                        >
                            <SubscriptionProductChip
                                product={productName}
                                style={{ marginRight: 10 }}
                            />
                            <ProductIcon
                                size={38}
                                style={{
                                    marginLeft: 10,
                                    marginBottom: 5,
                                }}
                            />
                        </View>

                        <View style={{}}>
                            <TextM
                                style={{
                                    marginTop: 10,
                                }}
                                fontWeight={"Medium"}
                                wrap
                            >
                                {subscriptionStatusNames?.[
                                    user?.subscription_state?.status
                                ] ?? "Pas d'abonnement actif"}
                            </TextM>
                            <LinkTextM
                                onPress={() => {
                                    setShowDetails(!showDetails)
                                }}
                                style={{
                                    fontSize: 10,
                                    marginTop: 8,
                                }}
                            >
                                Afficher les détails
                                <FontAwesome5
                                    name={
                                        !showDetails
                                            ? "chevron-down"
                                            : "chevron-up"
                                    }
                                    style={{ marginLeft: 4 }}
                                    size={10}
                                    solid
                                    color={theme.colors.primary}
                                />
                            </LinkTextM>
                        </View>

                        {showDetails && (
                            <View
                                style={{
                                    paddingLeft: 10,
                                    borderLeftWidth: 1.5,
                                    borderColor: theme.colors.primary,
                                }}
                            >
                                {currentTableData && (
                                    <PrivilegesChecklistM
                                        data={currentTableData}
                                        tinyMode
                                        style={{ marginTop: 10 }}
                                    />
                                )}
                                {isSubscriptionPaused(user) &&
                                    user?.subscription_state?.end_date &&
                                    user?.subscription_state?.end_date !==
                                        "-" && (
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                alignItems: "flex-start",
                                                marginTop: 10,
                                            }}
                                        >
                                            <FontAwesome5
                                                name={"pause"}
                                                solid
                                                color={theme.colors.primary}
                                                style={{
                                                    marginRight: 6,
                                                    marginTop: 1,
                                                    width: 18,
                                                }}
                                                size={16}
                                            />
                                            <TextM style={{}} wrap>
                                                Date de suspension : le{" "}
                                                {moment(
                                                    user?.subscription_state
                                                        ?.end_date
                                                )?.format("DD MMMM YYYY")}
                                            </TextM>
                                        </View>
                                    )}

                                {/* If no planned subscription */}
                                {!isSubscriptionPaused(user) &&
                                    !isSubscriptionRecurring(user) &&
                                    !isSubscriptionTrialing(user) &&
                                    user?.subscription_state?.end_date !==
                                        "-" && (
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                alignItems: "flex-start",
                                                marginTop: 10,
                                            }}
                                        >
                                            <FontAwesome5
                                                name={"calendar-times"}
                                                solid
                                                color={theme.colors.primary}
                                                style={{
                                                    marginRight: 6,
                                                    marginTop: 1,
                                                    width: 18,
                                                }}
                                                size={16}
                                            />
                                            <TextM style={{}} wrap>
                                                Date de fin de l&apos;abonnement
                                                : le{" "}
                                                {moment(
                                                    user?.subscription_state
                                                        ?.end_date
                                                )?.format("DD MMMM YYYY")}
                                            </TextM>
                                        </View>
                                    )}

                                {nextPaymentAmount > 0 && (
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "flex-start",
                                            marginTop: 10,
                                        }}
                                    >
                                        <FontAwesome5
                                            name={"file-invoice-dollar"}
                                            solid
                                            color={theme.colors.primary}
                                            style={{
                                                marginRight: 6,
                                                marginTop: 1,
                                                width: 18,
                                            }}
                                            size={16}
                                        />
                                        <TextM style={{}} wrap>
                                            Prochain paiement :{" "}
                                            {nextPaymentAmount}€ le{" "}
                                            {moment(nextPaymentAttempt)?.format(
                                                "DD MMMM YYYY"
                                            )}{" "}
                                        </TextM>
                                    </View>
                                )}

                                {/* Only show this if planned subscription + (committed or after march) */}
                                {user?.subscription_state?.planned_start_date &&
                                    Math.abs(
                                        moment().diff(
                                            moment(
                                                user?.subscription_state
                                                    ?.planned_start_date
                                            ),
                                            "months"
                                        )
                                    ) <= 2 && (
                                        <>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "flex-start",
                                                    marginTop: 10,
                                                }}
                                            >
                                                <FontAwesome5
                                                    name={"arrow-right"}
                                                    solid
                                                    color={theme.colors.primary}
                                                    style={{
                                                        marginRight: 6,
                                                        marginTop: 1,
                                                        width: 18,
                                                    }}
                                                    size={16}
                                                />
                                                {isSubscriptionPaused(user) ? (
                                                    <TextM style={{}} wrap>
                                                        Reprise en{" "}
                                                        {
                                                            user
                                                                ?.subscription_state
                                                                ?.planned_plan
                                                        }{" "}
                                                        prévue le{" "}
                                                        {formatDate(
                                                            moment(
                                                                user
                                                                    ?.subscription_state
                                                                    ?.planned_start_date
                                                            )
                                                        )}
                                                    </TextM>
                                                ) : (
                                                    <TextM style={{}} wrap>
                                                        Passage en{" "}
                                                        {
                                                            user
                                                                ?.subscription_state
                                                                ?.planned_plan
                                                        }{" "}
                                                        prévu le{" "}
                                                        {formatDate(
                                                            moment(
                                                                user
                                                                    ?.subscription_state
                                                                    ?.planned_start_date
                                                            )
                                                        )}
                                                    </TextM>
                                                )}
                                            </View>
                                            {!currentTableData &&
                                                plannedTableData && (
                                                    <PrivilegesChecklistM
                                                        data={plannedTableData}
                                                        tinyMode
                                                        style={{ marginTop: 5 }}
                                                    />
                                                )}
                                            {currentTableData &&
                                                plannedTableData && (
                                                    <TextM
                                                        fontWeight={"Regular"}
                                                        fontSize={10}
                                                        wrap
                                                        style={{
                                                            marginTop: 5,
                                                            marginBottom: 4,
                                                        }}
                                                    >
                                                        ={" "}
                                                        {
                                                            plannedTableData?.product_slots
                                                        }
                                                    </TextM>
                                                )}
                                        </>
                                    )}

                                {commitmentEndsAtFormatted && (
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "flex-start",
                                            marginTop: 10,
                                        }}
                                    >
                                        <FontAwesome5
                                            name={"handshake"}
                                            solid
                                            color={theme.colors.primary}
                                            style={{
                                                marginRight: 6,
                                                marginTop: 1,
                                                width: 18,
                                            }}
                                            size={16}
                                        />
                                        <TextM style={{}} wrap>
                                            Date de fin de l&apos;engagement :
                                            le {commitmentEndsAtFormatted}
                                        </TextM>
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                </ProfileSection>
            )}
            {!hideManageSection && (
                <ProfileSection
                    title={"Gérer"}
                    noBorder
                    style={{
                        paddingBottom: 20,
                        paddingTop: 20,
                        width: "100%",
                    }}
                >
                    {!user?.subscription_state?.is_manual_sub && (
                        <>
                            <FilledButtonM
                                mode={"outlined"}
                                icon={"file-invoice-dollar"}
                                color={theme.colors.primary}
                                style={{ marginTop: 20 }}
                                onPress={() => {
                                    handleOpenPaymentCollectionDayModal()
                                }}
                                labelStyle={{ fontSize: 12, height: 16 }}
                                contentStyle={{ height: 30 }}
                                label={
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <TextM
                                            wrap
                                            fontWeight={"ExtraBold"}
                                            fontSize={12}
                                            color={theme.colors.primary}
                                        >
                                            {payment_collection_day?.toUpperCase()}
                                        </TextM>
                                        {loading && (
                                            <ActivityIndicator
                                                color={theme.colors.primary}
                                                size="small"
                                                style={{ marginLeft: 15 }}
                                            />
                                        )}
                                    </View>
                                }
                                disabled={loading}
                            />

                            {
                                <ChangePaymentCollectionDayModal
                                    handleShowModal={
                                        handleOpenPaymentCollectionDayModal
                                    }
                                    isOpen={openPaymentCollectionDayModal}
                                    data={user}
                                    apiRequest={props.apiRequest}
                                    onUpdatePaymentCollectionDay={
                                        handleUpdatePaymentCollectionDay
                                    }
                                />
                            }

                            <FilledButtonM
                                mode={"outlined"}
                                icon={"credit-card"}
                                color={theme.colors.primary}
                                onPress={() => {
                                    if (IS_WEB) {
                                        window.open(
                                            billingPortalUrl +
                                                "/payment-methods"
                                        )
                                    } else {
                                        WebBrowser.openBrowserAsync(
                                            billingPortalUrl +
                                                "/payment-methods"
                                        )
                                    }
                                }}
                                labelStyle={{ fontSize: 12, height: 16 }}
                                contentStyle={{ height: 30 }}
                                label={"Mon moyen de paiement"}
                            />
                            <FilledButtonM
                                mode={"outlined"}
                                icon={"file-invoice"}
                                color={theme.colors.primary}
                                onPress={() => {
                                    if (IS_WEB) {
                                        window.open(billingPortalUrl)
                                    } else {
                                        WebBrowser.openBrowserAsync(
                                            billingPortalUrl
                                        )
                                    }
                                }}
                                labelStyle={{ fontSize: 12, height: 16 }}
                                contentStyle={{ height: 30 }}
                                label={"Mes factures"}
                            />
                            {onOpenInvoices && (
                                <FilledButtonM
                                    mode={"outlined"}
                                    icon={"file-invoice-dollar"}
                                    onPress={onOpenInvoices}
                                    labelStyle={{ fontSize: 12, height: 16 }}
                                    contentStyle={{ height: 30 }}
                                    label={"Factures à régler"}
                                />
                            )}
                        </>
                    )}

                    <FilledButtonM
                        mode={"outlined"}
                        icon={"whatsapp"}
                        color={theme.colors.primary}
                        onPress={() => {
                            const url = "https://wa.me/message/FCOBQ6PCPMBJC1"
                            if (IS_WEB) {
                                window.open(url)
                            } else {
                                WebBrowser.openBrowserAsync(url)
                            }
                        }}
                        labelStyle={{ fontSize: 12, height: 16 }}
                        contentStyle={{ height: 30 }}
                        label={"Contacter le support"}
                    />
                </ProfileSection>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        request: state.api.getSubscribePricing?.request,
        success: state.api.getSubscribePricing?.success,
        error: state.api.getSubscribePricing?.error,
        user: state.data.formData?.user,
        billingPortalUrl: state.data.formData?.billingPortalUrl,
        pricingTableData: state.data.formData?.pricingTableData,
        schoolSubjects: state.data.formData?.schoolSubjects,
        pricingTableDataNextMode: state.data.formData?.pricingTableDataNextMode,
    }
}

const mapDispatchToProps = {
    apiRequestWithPrerequest,
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(MySubscriptionInfos)
